<script setup>
  import { reactive, ref } from 'vue';

  import { authService } from '@/services/auth-service.js';

  const form = reactive({
    email: '',
    password: ''
  })

const loading = ref(false)
const error = ref(null)

const login = async () => {
  try {
    loading.value = true
    error.value = null

    const result = await authService.login(form.email,  form.password);

    console.log(result);

    if(result) {
      if(result.data && result.data.twoFactorRedirect){
        window.location.href = '/2fa/verify'
      }else {
         window.location.href = '/'
      }
    }else{
      error.value = 'Login error'
    }

  } catch (e) {
    error.value = e.response?.data?.message || 'Login error'
  } finally {
    loading.value = false
  }
}

  const togglePassword = () => {
    const input = document.getElementById('password');
    input.type = input.type === 'password' ? 'text' : 'password';
  }

  const goToReset = () => {
    window.location.href = '/forgot-password'
  }

  const goToLoginByCode = () => {
    window.location.href = '/login-by-otp'
  }
</script>

<template>
    <div class="page">
      <div class="wrapper">


        <div class="card-form">

          <div class="logo">
            <div class="my-4" id="logo-image"></div>
          </div>
          <form @submit.prevent="login" class="p-4">

          <div v-if="error" class="alert alert-error">
              {{ error }}
          </div>
          <div class="input-group">
            <input type="text" v-model="form.email" placeholder="Username">
          </div>

          <div class="input-group password-wrapper">
            <input type="password" v-model="form.password" id="password" placeholder="Password">
            <button class="toggle" type="button"  @click="togglePassword()">👁</button>
          </div>

          <button class="btn-button" :disabled="loading">
            {{ loading ? 'Loading...' : 'Login' }}
          </button>
            <div><br></div>
            <button class="btn-button" :disabled="loading" @click="goToLoginByCode()">
             Login by code
            </button>
            <div><br></div>

            <button class="btn-button" type="button" :disabled="loading" @click="goToReset()">
              Forgot your password?
            </button>


          </form>


        </div>

        <div class="footer">
          Impact Journals, LLC
        </div>

      </div>
    </div>

</template>

<style>
.alert {
  padding: 10px !important;
  margin-bottom: 15px !important;
  border-radius: 6px !important;
  font-size: 14px !important;
}

.alert-error {
  background-color: #ffe5e5 !important;
  color: #d60000 !important;
}

.alert-success {
  background-color: #e6ffed !important;
  color: #0a7f2e !important;
}

  div.card-form {
    min-width: 500px;
  }

  #authorization-progress {
    width: 3rem;
    height: 3rem;
    color: var(--purple);;
  }
  #authorization-state {
    font-size: 10px;
    color: gray;
    margin-top: 5px;
  }

  #logo-image {
    width: 100px;
    height: 100px;
    background-image: url("/logo_purple.png");
    background-size: contain;
    margin: 0 auto;
  }

  #footer {
    text-align: center;
    font-size: 11px;
    color: gray;
  }

   body {
     margin: 0;
     font-family: Arial, sans-serif;
     background: #f5f5f5;
   }

  .page {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
  }

  .wrapper {
    width: 600px;
    border: 1px solid #ddd;
    border-radius: 6px;
    background: #fafafa;
    padding: 40px;
    text-align: center;
  }

  .logo {
    margin-bottom: 20px;
  }

  .logo img {
    width: 80px;
  }

  .card-form {
    background: #eee;
    border: 1px solid #bbb;
    border-radius: 4px;
    padding: 30px;
    width: 350px;
    margin: auto;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  }

  .input-group {
    margin-bottom: 15px;
    position: relative;
  }

  input {
    width: 100%;
    padding: 12px;
    border: 1px solid #9aa5b1;
    border-radius: 4px;
    font-size: 14px;
  }

  .password-wrapper {
    display: flex;
  }

  .password-wrapper input {
    flex: 1;
    border-right: none;
    border-radius: 4px 0 0 4px;
  }

  .toggle {
    width: 45px;
    border: 1px solid #9aa5b1;
    border-left: none;
    background: #e5e7eb;
    cursor: pointer;
    border-radius: 0 4px 4px 0;
  }

  .btn-button {
    width: 100% !important;
    padding: 12px  !important;
    background: #8a0f63  !important;
    color: white  !important;
    border: none  !important;
    border-radius: 4px !important;
    font-size: 16px  !important;
    cursor: pointer  !important;
  }

  .btn:hover {
    background: #6d0c4e;
  }

  .forgot {
    margin-top: 15px;
    color: #8a0f63;
    font-size: 14px;
    cursor: pointer;
  }

  .footer {
    margin-top: 15px;
    font-size: 12px;
    color: #666;
  }

</style>
